import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FormGroup, Form, Input, Label, Button, Row, Col } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import UserContext from "../auth/UserContext";
import ValetApi from "../api/Api";
import RegionDropdown from "../components/RegionDropdown";
import "./AddLocationForm.css";

const INITIAL_VALUES = {
    name: "",
    regionId: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    phone: "",
};

const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    regionId: Yup.string().required("Region is required"),
    address: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    zipCode: Yup.string().required("Zip code is required"),
    phone: Yup.string().required("Phone number is required"),
});

const AddLocationForm = () => {
    const history = useHistory();
    const { addLocation } = useContext(UserContext);
    const [regions, setRegions] = useState([]);

    useEffect(() => {
        async function fetchRegions() {
            try {
                const regionsData = await ValetApi.getAllRegions();
                setRegions(regionsData.data.regions);
            } catch (error) {
                console.error("AddLocationForm Error fetching regions:", error);
            }
        }
        fetchRegions();
    }, []);

    const formik = useFormik({
        initialValues: INITIAL_VALUES,
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const result = await addLocation(values);
            if (result?.success) {
                resetForm();
                history.push("/admin/setup");
            }
        },
    });

    return (
        <Row className="justify-content-center add-location-page">
            <Col
                xs={12}
                md={7}
                lg={6}>
                <Form
                    className="add-location-form"
                    onSubmit={formik.handleSubmit}>
                    <FormGroup className="add-location-group">
                        <RegionDropdown
                            regions={regions}
                            selectedRegionId={formik.values.regionId}
                            onChange={(regionId) => formik.setFieldValue("regionId", regionId)}
                        />
                        {formik.touched.regionId && formik.errors.regionId && <div className="text-danger">{formik.errors.regionId}</div>}
                    </FormGroup>
                    <FormGroup className="add-location-group">
                        <Label htmlFor="name">Location Name</Label>
                        <Input
                            className="add-location-input"
                            id="name"
                            name="name"
                            type="text"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.name && Boolean(formik.errors.name)}
                        />
                        {formik.touched.name && formik.errors.name && <div className="invalid-feedback">{formik.errors.name}</div>}
                    </FormGroup>
                    <FormGroup className="add-location-group">
                        <Label htmlFor="address">Address</Label>
                        <Input
                            className="add-location-input"
                            id="address"
                            name="address"
                            type="text"
                            value={formik.values.address}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.address && Boolean(formik.errors.address)}
                        />
                        {formik.touched.address && formik.errors.address && <div className="invalid-feedback">{formik.errors.address}</div>}
                    </FormGroup>
                    <FormGroup className="add-location-group">
                        <Label htmlFor="city">City</Label>
                        <Input
                            className="add-location-input"
                            id="city"
                            name="city"
                            type="text"
                            value={formik.values.city}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.city && Boolean(formik.errors.city)}
                        />
                        {formik.touched.city && formik.errors.city && <div className="invalid-feedback">{formik.errors.city}</div>}
                    </FormGroup>
                    <FormGroup className="add-location-group">
                        <Label htmlFor="state">State</Label>
                        <Input
                            className="add-location-input"
                            id="state"
                            name="state"
                            type="text"
                            value={formik.values.state}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.state && Boolean(formik.errors.state)}
                        />
                        {formik.touched.state && formik.errors.state && <div className="invalid-feedback">{formik.errors.state}</div>}
                    </FormGroup>
                    <FormGroup className="add-location-group">
                        <Label htmlFor="zipCode">Zip</Label>
                        <Input
                            className="add-location-input"
                            id="zipCode"
                            name="zipCode"
                            type="text"
                            value={formik.values.zipCode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.zipCode && Boolean(formik.errors.zipCode)}
                        />
                        {formik.touched.zipCode && formik.errors.zipCode && <div className="invalid-feedback">{formik.errors.zipCode}</div>}
                    </FormGroup>
                    <FormGroup className="add-location-group">
                        <Label htmlFor="phone">Phone</Label>
                        <Input
                            className="add-location-input"
                            id="phone"
                            name="phone"
                            type="text"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.phone && Boolean(formik.errors.phone)}
                        />
                        {formik.touched.phone && formik.errors.phone && <div className="invalid-feedback">{formik.errors.phone}</div>}
                    </FormGroup>
                    <Button
                        color="primary"
                        className="add-location-submit"
                        type="submit">
                        Add Location
                    </Button>
                </Form>
            </Col>
        </Row>
    );
};

export default AddLocationForm;
